import { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import { trackFeature } from '@/utils/adobeLaunch';
import { t } from '@/utils/i18n';
import { selectConfigurations } from '@/redux/draft/getters/selectConfigurations';
import { useFocus } from '@/components/common/focus';
import { CaretRight } from '@/components/common/icons/Caret';
import { SubPanel } from '@/components/common/panel/panel';
import { AsyncDesignLayers } from '../design-layers/AsyncDesignLayers';
import type { ProductTypePanelComponent } from './ProductTypePanel';
import './ProductTypePanel.scss';

enum SubPanels {
  None,
  Layers,
}

interface StickerPanelProps {
  Panel: ProductTypePanelComponent;
}

export const ProductTypePanelWithLayers: FunctionComponent<StickerPanelProps> = ({ Panel }) => {
  const [activeSubPanel, setActiveSubPanel] = useState(SubPanels.None);
  const configurations = useSelector(selectConfigurations);
  const [settingsPanel, focusSettingsPanel] = useFocus();

  const handleLayersClick = () => {
    trackFeature('design-layers');
    setActiveSubPanel(SubPanels.Layers);
  };

  const handleBackClick = () => {
    setActiveSubPanel(SubPanels.None);
    focusSettingsPanel();
  };

  const toggle =
    configurations.length > 0 ? (
      <button className="design-layers__link" onClick={handleLayersClick} type="button">
        {t('layerPanel.action')}
        <CaretRight />
      </button>
    ) : undefined;

  return (
    <Panel active={activeSubPanel === SubPanels.None} panelRef={settingsPanel} toggle={toggle}>
      <SubPanel
        active={activeSubPanel === SubPanels.Layers}
        headline={t('layerPanel.action')}
        parent={t('productInfoPanel.label')}
        className="design-layers__panel"
        onBack={handleBackClick}
      >
        <AsyncDesignLayers />
      </SubPanel>
    </Panel>
  );
};
